import { Link, useRouter } from "@tanstack/react-router";
import { Phone } from "lucide-react";
import logo from "@/assets/crs-logo-white.webp";
import { SITE } from "@/lib/site";
import { resolvePagePhone } from "@/lib/nav-config";

export function LpFunnelFooter() {
  const router = useRouter();
  const phone = resolvePagePhone(router.state.location.pathname);

  return (
    <footer className="bg-primary text-primary-foreground mt-16">
      <div className="container-page py-8 flex flex-col gap-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <img
              src={logo}
              alt="CRS Energy"
              width={900}
              height={345}
              className="h-9 w-auto"
              decoding="async"
            />
            <p className="text-xs text-primary-foreground/70">
              © {new Date().getFullYear()} {SITE.legalName}. All rights reserved.
            </p>
          </div>
          <a
            href={phone.tel}
            className="inline-flex items-center gap-2 rounded-full bg-accent text-accent-foreground px-5 py-2.5 text-sm font-semibold hover:bg-accent/90 transition-colors shadow-cta"
          >
            <Phone className="h-4 w-4" aria-hidden />
            {phone.label}
          </a>
        </div>
        <nav aria-label="Legal" className="flex flex-wrap items-center justify-center sm:justify-start gap-x-5 gap-y-2 text-sm">
          <Link to="/privacy" className="text-primary-foreground/85 hover:text-primary-foreground transition-colors">
            Privacy
          </Link>
          <Link to="/data-protection" className="text-primary-foreground/85 hover:text-primary-foreground transition-colors">
            Data Protection
          </Link>
          <Link to="/contact" className="text-primary-foreground/85 hover:text-primary-foreground transition-colors">
            Contact
          </Link>
        </nav>
      </div>
    </footer>
  );
}
